import * as configcat from "configcat-js";

const logger = configcat.createConsoleLogger(configcat.LogLevel.Info)
const configCatClient = configcat.getClient(process.env.VUE_APP_CONFIG_CAT_ID, // <-- This is the actual SDK Key for your Production Environment environment
  configcat.PollingMode.AutoPoll,
  {
    logger: logger
  });

export const checkFeatureFlag = async (name) => {
    return configCatClient.getValueAsync(name, false);
}